import React from "react";
import styled from "styled-components";
const Wrapper = styled.div`
  position: ${(props) => (props.city ? "relative" : "absolute")}!important;
  z-index: 1;

  bottom: ${(props) => (props.city ? "10px" : "150px")}!important;
  width: 100%;
  text-align: center;
  h4 {
    position: ${(props) => (props.city ? "relative" : "absolute")}!important;
    font-family: ${({ theme }) => theme.fonts.sofia};
    font-style: normal;

    font-weight: ${(props) => (props.city ? "normal" : "lighter")};
    font-size: 1.4rem !important;
    text-transform: capitalize;
    bottom: ${(props) => (props.city ? "0px" : "-60px")}!important;
    left: 50%;
    transform: translateX(-50%);
    color: ${({ theme, city }) =>
      city ? theme.yellowish : theme.white}!important;
  }
  @media (max-width: 768px) {
    h4 {
      color: ${({ theme }) => theme.yellowish};
    }
  }
`;

function CardUpperText({ children, city }) {
  return (
    <Wrapper city={city}>
      <h4>{children}</h4>
    </Wrapper>
  );
}

export default CardUpperText;
